<template>
    <div class="map"/>
</template>

<script>
    import mapStyle from './map-style.json';

    const CUSTOM_MAP_TYPE_ID = 'DATATRANS_MAP_STYLE';
    const CUSTOM_MAP_TYPE_NAME = 'DATATRANS';

    import GoogleMapsApiLoader from 'util/google-maps';
    import staticPath from 'framework/filters/staticPath';

    export default {
        props: {
            lat: {
                type: Number,
                required: true,
            },

            lng: {
                type: Number,
                required: true,
            },

            zoom: {
                type: Number,
                default: 12,
            },

            /** @type {IMapMarker[]} */
            markers: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                MapsApi: null,
                map: null,
            };
        },

        computed: {
            mapOptions() {
                return {
                    disableDefaultUI: true,
                    zoomControl: true,
                    streetViewControl: true,
                    center: {
                        lat: this.lat,
                        lng: this.lng,
                    },
                    zoom: this.zoom,
                };
            },
        },

        methods: {

            /**
             * Creates a new marker
             * @param {string} iconPath
             * @param {number} lat
             * @param {number} lng
             * @return {Marker}
             */
            createMarker(iconPath = staticPath('img/ic_32_location.svg'), lat, lng) {
                const marker = new this.MapsApi.Marker({
                    icon: iconPath,
                    animation: this.MapsApi.Animation.DROP,
                });

                marker.setPosition({ lat, lng });
                marker.setMap(this.map);
                return marker;
            },

            /**
             * Initializes the map
             * @param {Document} mapEl
             * @return {object}
             */
            createMap(mapEl) {
                const CustomMapType = new this.MapsApi.StyledMapType(mapStyle, { name: CUSTOM_MAP_TYPE_NAME });
                const map = new this.MapsApi.Map(mapEl, this.mapOptions);
                map.mapTypes.set(CUSTOM_MAP_TYPE_ID, CustomMapType);
                map.setMapTypeId(CUSTOM_MAP_TYPE_ID);
                return map;
            },

        },

        mounted() {
            GoogleMapsApiLoader()
                .then(MapsApi => {
                    this.MapsApi = MapsApi;
                    this.map = this.createMap(this.$el);
                    this.markers.forEach((marker) => {
                        this.createMarker(marker.icon, marker.lat, marker.lng);
                    });
                }, error => {
                    throw error;
            });
        },
    };
</script>
